
export const getHubbelPageData = (onPageData,reload='1') => {
  console.log(reload);
  let index = 0,
    randomObject;

    if (localStorage.getItem("_hubbel_checker_current_object_index_")) {
      index = localStorage.getItem("_hubbel_checker_current_object_index_");
      if(reload === '1' || reload === 'special'){
        // reload === 'special' this conditon is for changing random page without going to next page  
        
        index++;
        // console.log("Reload",index)
        index %= onPageData.length;
        console.log(index,onPageData.length)
        randomObject = onPageData[index];
      }else{
        console.log("Return the previous object")
        randomObject = onPageData[index];
      }
      localStorage.setItem("_hubbel_checker_current_object_index_", index);
    } else {
      randomObject = onPageData[0];
      localStorage.setItem("_hubbel_checker_current_object_index_", 0);
    }
    return randomObject;
};

export function enterFullScreen(elem) {
  if (elem.requestFullScreen) {
    elem.requestFullScreen();
} else if (elem.webkitRequestFullScreen) {
    elem.webkitRequestFullScreen();
} else if (elem.mozRequestFullScreen) {
    elem.mozRequestFullScreen();
} else if (elem.msRequestFullscreen) {
    elem.msRequestFullscreen();
} else if (elem.webkitEnterFullscreen) {
   elem.webkitEnterFullscreen();
}
}


export function exitFullScreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) { /* Firefox */
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) { /* IE/Edge */
    document.msExitFullscreen();
  }
}


export const isMobile =()=>{
  const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
  ];
  
  return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
  });
}
export const addDeviceTypeInHtml = (browserName)=>{
  let classNames = [];
if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) classNames.push('device-type-ios');
if (navigator.userAgent.match(/android/i)) classNames.push('device-type-android');

let html = document.getElementsByTagName('html')[0];

if (classNames.length) classNames.push(browserName);
if (html.classList) html.classList.add.apply(html.classList, classNames);
return;
} 

//open modal for image
export function openImageViewModal(imageUrl) {
 
  if (document.getElementById("imageModal")) {
    return;
  }

  const modalContainer = document.createElement("div");
  modalContainer.id = "imageModal";
  modalContainer.style.display = "block";
  modalContainer.style.position = "fixed";
  modalContainer.style.top = "0";
  modalContainer.style.left = "0";
  modalContainer.style.width = "100%";
  modalContainer.style.height = "100%";
  modalContainer.style.backgroundColor = "rgba(0,0,0,0.7)";
  modalContainer.style.zIndex = "9999";

  const closeButton = document.createElement("button");
  closeButton.innerHTML = "Close";
  closeButton.style.position = "absolute";
  closeButton.style.top = "10px";
  closeButton.style.right = "10px";
  closeButton.style.padding = "5px";
  closeButton.style.cursor = "pointer";
  closeButton.style.background = "none";
  closeButton.style.border = "none";
  closeButton.style.color = "#fff";

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) {
      return;
    }
    cleaned = true;
    const modal = document.getElementById("imageModal");
    if (modal) {
      document.body.removeChild(modal);
    }
    document.removeEventListener("keydown", handleKeyDown);
    window.removeEventListener("popstate", handlePopState);
    document.removeEventListener("fullscreenchange", handleFullscreenChange);
    document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
  };

  // Back button: just clean up
  const handlePopState = () => {
    cleanup();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      cleanup();
    }
  };

  // When fullscreen is exited (e.g., by the browser consuming Escape),
  // check if modal is still open and close it
  const handleFullscreenChange = () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      const modal = document.getElementById("imageModal");
      if (modal) {
        cleanup();
      }
    }
  };

  closeButton.onclick = cleanup;
  modalContainer.onclick = cleanup;

  modalContainer.appendChild(closeButton);

  const imageView = document.createElement("img");
  imageView.src = imageUrl;
  imageView.style.display = "block";
  imageView.style.margin = "auto";
  imageView.style.maxWidth = "80%";
  imageView.style.maxHeight = "80%";
  imageView.style.marginTop = "5%";
  imageView.onclick = (event) => {
    event.stopPropagation();
  };
  
  modalContainer.appendChild(imageView);
  document.body.appendChild(modalContainer);

  window.addEventListener("popstate", handlePopState);
  document.addEventListener("keydown", handleKeyDown);
  document.addEventListener("fullscreenchange", handleFullscreenChange);
  document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
  
}
